import ServicePage from './page';
import { mutualFundsData } from '@/mocks/servicePagesBatch2';

export default function MutualFundsPage() {
  return <ServicePage data={mutualFundsData} />;
}